module.exports = __webpack_public_path__ + "img/PC8.567db499.png";